import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UploadFile} from '../../../../../../models/consultation/UploadFile';
import {FormatBytes} from '../../../../../../utils/utilities';

@Component({
    selector: 'app-upload-file',
    imports: [],
    templateUrl: './upload-file.component.html',
    styleUrl: './upload-file.component.scss'
})
export class UploadFileComponent {

    // region Variables

    @Input() file: UploadFile | undefined;
    @Output() onDeleteFile = new EventEmitter();
    protected readonly FormatBytes = FormatBytes;

    // endregion

    // Constructor
    constructor() {
    }

    // Init
    ngOnInit() {
    }

    // Delete File
    deleteFile() {

        this.onDeleteFile.emit(this.file);

    }

}
